export default __webpack_public_path__ + "static/media/FaceAndEmotion.3fb46220.png";